import React from 'react';
import * as css from './company.module.scss';
import Head from 'components/merchant/head/Head';
import Step from 'components/merchant/step/Step';
import BottomButton from 'components/merchant/bottom-button/BottomButton';
import * as antdMobile from 'antd-mobile';
import * as antd from 'antd';
import {inject, observer} from 'mobx-react';
import Gender from 'enum/CompanyGender';

const Company = ({merchant:merchantStore}) => {


    const {company} = merchantStore;
    const [form] = antd.Form.useForm()
    const {getFieldProps} = form;

    return (
        <div className={css.merchantCompany}>
            <Head/>
            <Step/>
            <div className={css.content}>
                <div className={css.titleFloor}>
                    <div className={css.title}>联系方式</div>
                    <div className={css.subTitle}>卖家入驻联系人信息</div>
                </div>

                <div className={css.container}>
                    {/* todo 1 这里有2个 name 属性错误 而且不应该写 onchange 和 value*/}
                    <antd.Form.Item noStyle name={'control'}>
                        <antdMobile.InputItem
                            placeholder='请填写真实姓名'
                            value={company.name}
                            onChange={value => {
                                company.name = value;
                            }}
                        >
                            姓名
                        </antdMobile.InputItem>
                    </antd.Form.Item>
                    <antd.Form.Item noStyle name={'control'}>
                        <antdMobile.InputItem
                            placeholder='请填写手机号'
                            value={company.mobilephone}
                            onChange={value => {
                                company.mobilephone = value;
                            }}
                            type='phone'
                        >
                            手机
                        </antdMobile.InputItem>
                    </antd.Form.Item>
                    <antd.Form.Item noStyle name={'gender'}>
                        <antdMobile.List.Item>
                            <span className={css.label}>性别</span>
                            <antdMobile.Radio
                                name='gender'
                                checked={company.gender === Gender.Male}
                                onChange={e => {
                                    company.gender = Gender.Male;
                                }}
                            >
                                男
                            </antdMobile.Radio>
                            <antdMobile.Radio
                                name='gender'
                                checked={company.gender === Gender.Female}
                                onChange={e => {
                                    company.gender = Gender.Female;
                                }}
                            >
                                女
                            </antdMobile.Radio>
                        </antdMobile.List.Item>
                    </antd.Form.Item>
                </div>
            </div>
            <BottomButton className={css.bottomBtn}/>
        </div>
    );
};

export default inject('merchant')(observer(Company));
